import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../CSS/Header.css';

const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isIndustryDropdownOpen, setIsIndustryDropdownOpen] = useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    // Reset dropdowns when closing mobile menu
    if (isMobileMenuOpen) {
      setIsIndustryDropdownOpen(false);
      setIsServicesDropdownOpen(false);
    }
  };

  const toggleIndustryDropdown = () => {
    setIsIndustryDropdownOpen(!isIndustryDropdownOpen);
  };

  const toggleServicesDropdown = () => {
    setIsServicesDropdownOpen(!isServicesDropdownOpen);
  };

  const handleNavigationClick = (dropdownType: 'industry' | 'services') => {
    // Close the specific dropdown when a navigation item is clicked
    if (dropdownType === 'industry') {
      setIsIndustryDropdownOpen(false);
    } else if (dropdownType === 'services') {
      setIsServicesDropdownOpen(false);
    }
  };

  const handleMobileNavigation = () => {
    // Close the entire mobile menu when any navigation link is clicked
    setIsMobileMenuOpen(false);
    setIsIndustryDropdownOpen(false);
    setIsServicesDropdownOpen(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        {/* Logo */}
        <Link to="/" className="logo">
          <div className="logo-icon">
            <img src="/Assets/Zemantics-Logo.svg" alt="Zemantics Logo" />
          </div>
        </Link>

                {/* Mobile Menu Button */}
        {!isMobileMenuOpen && (
          <button
            className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
        )}

        {/* Desktop Navigation */}
        <nav className="nav desktop-nav">
          <ul className="nav-list">
            <li className="nav-item dropdown">
              <button 
                className="nav-link dropdown-toggle"
                onClick={toggleIndustryDropdown}
              >
                Industry
              </button>
              {isIndustryDropdownOpen && (
                <ul className="dropdown-menu">
                  <li><Link to="/finance-accounting" className="dropdown-item">Finance & Accounting</Link></li>
                  <li><Link to="/healthcare" className="dropdown-item">Healthcare</Link></li>
                  <li><Link to="/edtech" className="dropdown-item">EdTech</Link></li>
                  <li><Link to="/logistics" className="dropdown-item">Logistics</Link></li>
                  <li><Link to="/retail" className="dropdown-item">Retail</Link></li>
                  <li><Link to="/pharmaceutical" className="dropdown-item">Pharmaceutical</Link></li>
                  <li><Link to="/human-resource" className="dropdown-item">Human Resource</Link></li>
                </ul>
              )}
            </li>
            <li className="nav-item dropdown">
              <button 
                className="nav-link dropdown-toggle"
                onClick={toggleServicesDropdown}
              >
                Our Services
              </button>
              {isServicesDropdownOpen && (
                <ul className="dropdown-menu">
                  <li><Link to="/aiml" className="dropdown-item">Artificial Intelligence And ML</Link></li>
                  <li><Link to="/dataengineering" className="dropdown-item">Data Engineering</Link></li>
                  <li><Link to="/generativeai" className="dropdown-item">Generative AI</Link></li>
                  <li><Link to="/softwareengineering" className="dropdown-item">Software Engineering For AI Products</Link></li>
                </ul>
              )}
            </li>
            <li className="nav-item">
              <Link to="/company" className="nav-link">Company</Link>
            </li>
            <li className="nav-item">
              <Link to="/contact" className="nav-link">Contact Us</Link>
            </li>
          </ul>
        </nav>

        {/* Mobile Menu Overlay */}
        {isMobileMenuOpen && (
          <div className="mobile-menu-overlay">
            <div className="mobile-menu-header">
              <div className="mobile-menu-logo">
                <img src="/Assets/Zemantics-Logo.svg" alt="Zemantics Logo" />
              </div>
              <button className="mobile-menu-close" onClick={toggleMobileMenu}>
                ✕
              </button>
            </div>
            
            <nav className="mobile-nav">
              <ul className="mobile-nav-list">
                <li className="mobile-nav-item">
                  <button 
                    className="mobile-nav-link dropdown-toggle"
                    onClick={toggleIndustryDropdown}
                  >
                    <span>Industry</span>
                    <span className={`dropdown-arrow ${isIndustryDropdownOpen ? 'up' : 'down'}`}>
                      <img 
                        src={isIndustryDropdownOpen ? "/Assets/Icons/down-arrow-icon.svg" : "/Assets/Icons/up-arrow-icon.svg"} 
                        alt={isIndustryDropdownOpen ? "Down arrow" : "Up arrow"} 
                      />
                    </span>
                  </button>
                  {isIndustryDropdownOpen && (
                    <ul className="mobile-dropdown-menu">
                      <li><Link to="/finance-accounting" className="mobile-dropdown-item" onClick={handleMobileNavigation}>Finance & Accounting</Link></li>
                      <li><Link to="/healthcare" className="mobile-dropdown-item" onClick={handleMobileNavigation}>Healthcare</Link></li>
                      <li><Link to="/edtech" className="mobile-dropdown-item" onClick={handleMobileNavigation}>EdTech</Link></li>
                      <li><Link to="/logistics" className="mobile-dropdown-item" onClick={handleMobileNavigation}>Logistics</Link></li>
                      <li><Link to="/retail" className="mobile-dropdown-item" onClick={handleMobileNavigation}>Retail</Link></li>
                      <li><Link to="/pharmaceutical" className="mobile-dropdown-item" onClick={handleMobileNavigation}>Pharmaceutical</Link></li>
                      <li><Link to="/human-resource" className="mobile-dropdown-item" onClick={handleMobileNavigation}>Human Resource</Link></li>
                    </ul>
                  )}
                </li>
                <li className="mobile-nav-item">
                  <button 
                    className="mobile-nav-link dropdown-toggle"
                    onClick={toggleServicesDropdown}
                  >
                    <span>Our Services</span>
                    <span className={`dropdown-arrow ${isServicesDropdownOpen ? 'up' : 'down'}`}>
                      <img 
                        src={isServicesDropdownOpen ? "/Assets/Icons/down-arrow-icon.svg" : "/Assets/Icons/up-arrow-icon.svg"} 
                        alt={isServicesDropdownOpen ? "Down arrow" : "Up arrow"} 
                      />
                    </span>
                  </button>
                  {isServicesDropdownOpen && (
                    <ul className="mobile-dropdown-menu">
                      <li><Link to="/aiml" className="mobile-dropdown-item" onClick={handleMobileNavigation}>Artificial Intelligence And ML</Link></li>
                      <li><Link to="/dataengineering" className="mobile-dropdown-item" onClick={handleMobileNavigation}>Data Engineering</Link></li>
                      <li><Link to="/generativeai" className="mobile-dropdown-item" onClick={handleMobileNavigation}>Generative AI</Link></li>
                      <li><Link to="/softwareengineering" className="mobile-dropdown-item" onClick={handleMobileNavigation}>Software Engineering For AI Products</Link></li>
                    </ul>
                  )}
                </li>
                <li className="mobile-nav-item">
                  <Link to="/company" className="mobile-nav-link" onClick={handleMobileNavigation}>Company</Link>
                </li>
                <li className="mobile-nav-item">
                  <Link to="/contact" className="mobile-nav-link" onClick={handleMobileNavigation}>Contact Us</Link>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header; 